import { KeyboardDatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import React from "react";
import { FilterPropsItem } from "./types";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { Tooltip } from "@material-ui/core";
import { FieldError } from "react-hook-form";
interface Props extends FilterPropsItem<MaterialUiPickersDate> {
  label: string;
  maxDate?: Date;
  tooltipTitle?: string;
  error?: FieldError;
}

const DateFilter: React.FC<Props> = ({
  selection,
  onChange,
  label,
  maxDate,
  tooltipTitle,
  error,
}) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <KeyboardDatePicker
        value={selection}
        onChange={(date) => onChange(date)}
        inputVariant="outlined"
        label={label}
        size={"small"}
        style={{ width: 200 }}
        format="dd.MM.yyyy"
        id={`${label}-date-picker`}
        error={!!error?.message}
        helperText={error?.message}
        maxDate={maxDate}
      />
      {!!tooltipTitle && (
        <Tooltip
          title={tooltipTitle}
          aria-label={`${label}-date-filter`}
          style={{ marginLeft: 5 }}
        >
          <HelpOutlineIcon color="disabled" />
        </Tooltip>
      )}
    </div>
  );
};

export default DateFilter;
